import { createStructuredSelector } from "reselect";
import {
    BASKET_MEDICINE,
    BASKET_MEDICINE_SUCCESS,
    BASKET_MEDICINE_ERROR,
    BASKET_MEDICINE_SEARCH_SET,
    BASKET_MEDICINE_SEARCH_CHANGE
} from "../actions";

export const NAME = 'basket';

export const BasketMedicine = (filters, stateFilter) => ({
    type: BASKET_MEDICINE,
    payload: { filters: filters, filtersState: stateFilter }
});

export const BasketMedicineSuccess = (data) => ({
    type: BASKET_MEDICINE_SUCCESS,
    payload: data
});

export const BasketMedicineError = (error) => ({
    type: BASKET_MEDICINE_ERROR,
    payload: error
});

export const BasketMedicineSearchSet = (data) => ({
    type: BASKET_MEDICINE_SEARCH_SET,
    payload: data
});

export const BasketMedicineSearchChangeSet = (data) => ({
    type: BASKET_MEDICINE_SEARCH_CHANGE,
    payload: data
});



const basket = (state) => state[NAME];

export const BasketMedicineSelector = createStructuredSelector({
    basket
})
